export const LOGO_HEIGHT = 38;
export const LOGO_WIDTH = 80;
